module.exports = __webpack_public_path__ + "img/CheckIcon.905f226f.svg";